// Hover functionality for 'Locations Menu' module
if (document.querySelector(".m-locations-menu")) {
  (function () {
    const locations = document.querySelectorAll(".m-locations-menu a");

    function hover() {
      locations.forEach((location) => location.classList.remove("active"));
      this.classList.add("active");
    }

    locations[0].classList.add("active");

    locations.forEach((location) => {
      location.addEventListener("mouseenter", hover);
    });

    locations.forEach((location) => {
      location.addEventListener("mouseleave", hover);
    });
  })();
}
